import React from 'react';
import { StyleSheet, View } from 'react-native';
import { CardView } from './CardView';
import Text from './Text';
import { rem } from './values';
import { IconEmma } from './icons/IconEmma';
import Spacer from './Spacer';
const WeLearnFromYouCard = React.memo(() => (<CardView style={styles.infoCard} noMargin>
    <IconEmma colorKey={'brand'} width={rem(32)} height={rem(32)}/>
    <Spacer w={rem(12)}/>
    <View style={styles.infoTextContainer}>
      <Text TextThin-14 Secondary>
        We learn from your edits. Keep editing to make Emma smarter.
      </Text>
    </View>
  </CardView>));
const styles = StyleSheet.create({
    infoCard: {
        paddingHorizontal: rem(16),
        paddingVertical: rem(12),
        borderRadius: rem(16),
        flexDirection: 'row',
        alignItems: 'center',
    },
    infoTextContainer: {
        flex: 1,
    },
});
export default WeLearnFromYouCard;
